const BRAND = "Drive Now Auto Haus";

const EXACT_TITLES = {
  "/": "Home",
  "/inventory": "Inventory",
  "/financing": "Financing",
  "/trade-in": "Trade In",
  "/prequalification": "Pre-Qualification",
  "/loan-calculator": "Loan Calculator",
  "/schedule-service": "Schedule Service",
  "/privacy": "Privacy Policy",
  "/terms": "Terms and Conditions",
  "/admin/login": "Admin Login",
  "/admin/accept-invite": "Accept Invite",
  "/admin/verify-email": "Verify Email",
  "/admin": "Dashboard",
  "/admin/inventory": "Inventory",
  "/admin/sold-vehicles": "Sold Vehicles",
  "/admin/deals": "Deals",
  "/admin/documents": "Documents",
  "/admin/operations": "Operations",
  "/admin/leads": "Track Leads",
  "/admin/service-requests": "Service Requests",
  "/admin/imagine": "Imagine",
  "/admin/outreach": "Outreach",
  "/admin/schedule": "Schedule",
  "/admin/users": "Users",
  "/admin/profile": "Profile",
};

const PREFIX_TITLES = [
  ["/inventory/", "Vehicle"],
  ["/mobile-photos/", "Mobile Photos"],
  ["/customer-info/", "Customer Information"],
  ["/service-quote/", "Service Quote"],
  ["/admin/vehicles/", "Vehicle"],
  ["/admin/sold-vehicles/", "Sold Vehicle"],
  ["/admin/deals/", "Deal"],
  ["/admin/leads/", "Lead"],
  ["/admin/service-requests/", "Service Request"],
];

function normalizePath(pathname) {
  if (!pathname || pathname === "/") return "/";
  return pathname.replace(/\/+$/, "") || "/";
}

export function titleForPath(pathname) {
  const path = normalizePath(pathname);
  if (EXACT_TITLES[path]) {
    return `${BRAND} - ${EXACT_TITLES[path]}`;
  }
  const prefix = PREFIX_TITLES.find(([start]) => path.startsWith(start.slice(0, -1) + "/"));
  if (prefix) {
    return `${BRAND} - ${prefix[1]}`;
  }
  return BRAND;
}

export function setDocumentTitle(pathname) {
  document.title = titleForPath(pathname);
}
